import { atomWithStorageWithDefault } from "@sunrise/utils";

/**
 * When a number value is set it means time since epoch at which the first experience was closed after being shown.
 */
export const alreadyShownFirstExperienceAtom = atomWithStorageWithDefault<
  null | number
>("shown-first-experience-tv", null);
